import { render, staticRenderFns } from "./jsonDataValidator.vue?vue&type=template&id=81b113ee&"
import script from "./jsonDataValidator.vue?vue&type=script&lang=js&"
export * from "./jsonDataValidator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports